import React from "react";
import Axios from "axios";
import { useState } from "react";
import { useRef } from "react";
import Swal from "sweetalert2";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function Careerform() {
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");

  const saveFile = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  // function refreshPage() {
  //   window.location.reload(false);
  // }

  const form = useRef(null);

  const handlesubmit = () => {
    form.current.reset(); //this will reset all the inputs in the form
  };

  const uploadFile = async (e) => {
    const formData1 = new FormData();
    formData1.append("file", file);
    formData1.append("fileName", fileName);
    // const res = Axios.post("http://localhost:3000/upload", formData1);
    // console.log(res);
  };
  uploadFile();

  const url = "http://localhost:3002/api/v1/Career";
  const [formData, setformData] = useState({
    name: "",
    email: "",
    gender: "female",
    dob: "",
    passingyear: "",
    designation: "",
    city: "",
    address: "",
    file: "",
    yearofexperience: "",
    lastorganization: "",
    noticeperiod: "",
    lastsalary: "",
    expectedsalary: "",
  });

  function submit(e) {
    e.preventDefault();
    const formData1 = new FormData();
    formData1.append("file", file);

    Axios.post("http://localhost:3002/upload", formData1).then((res) => {
      console.log("resresresres111111111111", res);
      if (res["data"]["status"]) {
        let path = res["data"]["path"];
        console.log("pathhhhh", path);
        console.log("1111111111111111111111111111111", formData);

        formData["file"] = path;
        console.log("formdataaa", formData);

        // refreshPage();
        handlesubmit();

        Axios.post(url, formData).then((res) => {
          // console.log(res.formData);
          if (res["status"]) {
            console.log("-----------------");

            let clearObj = {
              name: "",
              email: "",
              gender: "female",
              dob: "",
              passingyear: "",
              designation: "",
              city: "",
              address: "",
              file: "",
              yearofexperience: "",
              lastorganization: "",
              noticeperiod: "",
              lastsalary: "",
              expectedsalary: "",
            };
            setformData(clearObj);
          } else {
          }
        });
      }
    });
  }

  function handle(e) {
    console.log("eeeee", e);
    let newdata = { ...formData };
    if (e.target.type !== "file") {
      console.log("22222222222222222", newdata);
      newdata[e.target.name] = e.target.value;
      setformData(newdata);
      console.log(newdata);
    } else {
      newdata["file"] = e.target.files[0];
      setformData(newdata);
      console.log(newdata);
    }
  }

  const [status, setStatus] = React.useState(0); // 0: no show, 1: show yes, 2: show no.

  const radioHandler = (status) => {
    setStatus(status);
  };

  const successAlert = () => {
    Swal.fire({
      title: "Form Submitted Successfully!",
      text: "ckeck your Email.",
      icon: "success",
    });
  };

  return (
    <div>
      <section className="services" id="services">
        <div className="container">
          <form
            ref={form}
            onSubmit={(e) => submit(e)}
            id="careerForm"
            encType="multipart/form-data"
          >
            <div className="row no-gutters">
              <div className="col-12">
                <div className="title text-center">
                  <h3>
                    <b>Enter your details</b>
                  </h3>
                </div>
              </div>
              <div className="col-5 form-group">
                <input
                  onChange={(e) => handle(e)}
                  type="text"
                  // value={formData.name}
                  name="name"
                  className="form-control"
                  id="name"
                  placeholder="Your Full Name"
                  required
                />
              </div>
              <div className="col-1"></div>

              <div className="col-5 form-group">
                <input
                  onChange={(e) => handle(e)}
                  // value={formData.email}
                  type="email"
                  className="form-control"
                  name="email"
                  id="email"
                  placeholder="Your Email"
                  required
                />
              </div>
              <div className="col-1"></div>
              <div className="col-5 form-group">
                <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label">
                    {/* {gender} */}
                  </FormLabel>
                  <RadioGroup
                    onChange={(e) => handle(e)}
                    // onChange={onChangeValue}
                    defaultValue="female"
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      onChange={(e) => handle(e)}
                      // onChange={(e) => setGender(e.target.value)}
                      name="gender"
                      value="female"
                      // checked={gender === "female"}
                      id="gender"
                      control={<Radio />}
                      label="Female"
                    />
                    <FormControlLabel
                      // onChange={(e) => setGender(e.target.value)}
                      name="gender"
                      onChange={(e) => handle(e)}
                      // checked={gender === "male"}
                      value="male"
                      id="gender"
                      control={<Radio />}
                      label="Male"
                    />
                    <FormControlLabel
                      onChange={(e) => handle(e)}
                      // onChange={(e) => setGender(e.target.value)}
                      name="gender"
                      id="gender"
                      value="other"
                      // checked={gender === "other"}
                      control={<Radio />}
                      label="Other"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="col-1"></div>
              <div className="col-5 form-group">
                <label>Date Of Birth:</label>
                <input
                  onChange={(e) => handle(e)}
                  // value={formData.dob}
                  type="date"
                  className="form-control"
                  name="dob"
                  id="dob"
                  placeholder="Date Of Birth"
                  required
                />
              </div>
              <div className="col-5 form-group">
                <input
                  onChange={(e) => handle(e)}
                  // value={formData.passingyear}
                  type="text"
                  className="form-control"
                  name="passingyear"
                  id="passingyear"
                  placeholder="Year Of Passing"
                />
              </div>
              <div className="col-1"></div>
              <div className="col-5 form-group">
                <input
                  onChange={(e) => handle(e)}
                  // value={formData.designation}
                  type="text"
                  className="form-control"
                  name="designation"
                  id="designation"
                  placeholder="Your designation"
                />
              </div>

              <div className="col-5 form-group">
                <input
                  onChange={(e) => handle(e)}
                  // value={formData.city}
                  type="city"
                  className="form-control"
                  name="city"
                  id="city"
                  placeholder="Your city/town"
                  required
                />
              </div>
              <div className="col-1"></div>
              <div className="col-5 form-group">
                <textarea
                  onChange={(e) => handle(e)}
                  // value={formData.address}
                  className="form-control"
                  id="address"
                  name="address"
                  rows="2"
                  placeholder="Your Address"
                  required
                ></textarea>
              </div>
              <div className="col-5 form-group"></div>
              <div className="col-1 form-group"></div>

              <div className="col-5 form-group">
                Upload resume: <br></br>
                <input
                  type="file"
                  id="resume"
                  name="uploaded_file"
                  onChange={saveFile}
                  // value={formData.resume}
                  // onChange={handleOnChange}
                  // onChange={(e) => handle(e)}
                />
                {/* <button onClick={uploadFile}>Upload</button> */}
              </div>
              {/* <div className="col-5 form-group">
                Current Date & Time: {moment}
              </div> */}
              <div className="col-12 form-group">
                <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label">
                    Experience level
                  </FormLabel>
                  <RadioGroup
                    defaultValue="fresher"
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      // value={formData.fresher}
                      control={<Radio />}
                      name="experiencelevel"
                      onChange={(e) => handle(e)}
                      label="Fresher"
                      id="fresher"
                      checked={status === 2}
                      onClick={(e) => radioHandler(2)}
                    />
                    <FormControlLabel
                      // value={formData.experience}
                      name="experiencelevel"
                      control={<Radio />}
                      onChange={(e) => handle(e)}
                      label="Experience"
                      id="experience"
                      checked={status === 1}
                      onClick={(e) => radioHandler(1)}
                    />
                    {status === 1 && (
                      <div class="col-md-12 form-group">
                        <input
                          type="text"
                          // value={formData.yearofexperience}
                          class="form-control custom-form-control mt-2 mb-4"
                          id="yearofexperience"
                          onChange={(e) => handle(e)}
                          name="yearofexperience"
                          placeholder="Year of experience"
                        />
                        <p id="error_msg_yoe" class="error_display"></p>

                        <input
                          type="text"
                          class="form-control custom-form-control mt-2 mb-4"
                          id="lastorganization"
                          onChange={(e) => handle(e)}
                          name="lastorganization"
                          placeholder="Last Organization"
                        />
                        <p id="error_msg_lowf" class="error_display"></p>

                        <input
                          type="text"
                          class="form-control custom-form-control mt-2 mb-4"
                          id="noticeperiod"
                          onChange={(e) => handle(e)}
                          name="noticeperiod"
                          placeholder="Current Notice Period"
                        />
                        <p id="error_msg_cnp" class="error_display"></p>

                        <input
                          type="text"
                          class="form-control custom-form-control mt-2 mb-4"
                          id="lastsalary"
                          onChange={(e) => handle(e)}
                          name="lastsalary"
                          placeholder="last drawn salary"
                        />
                        <p id="error_msg_lds" class="error_display"></p>

                        <input
                          type="text"
                          class="form-control custom-form-control mt-2 mb-4"
                          id="expectedsalary"
                          onChange={(e) => handle(e)}
                          name="expectedsalary"
                          placeholder="Expected salary"
                        />
                        <p id="error_msg_lds" class="error_display"></p>
                      </div>
                    )}
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="col-1"></div>

              <div className="text-center">
                <button
                  onChange={(e) => submit(e)}
                  onClick={successAlert}
                  class="btm btn-orange"
                  type="submit"
                  title="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}
// const rootElement = document.getElementById("root");
// ReactDOM.render(<Experienceclick />, rootElement);

// export default Careerform;
